{
    "NAME": "Mode de l'appareil",
    "DeviceModal_AddTitle": "Ajouter un appareil",
    "DeviceModal_ChangeTitle": "Changer de dispositif",
    "DeviceModal_ViewTitle": "Afficher l'appareil",
    "DeviceModal_PromptMessage": "Vous avez des modifications non enregistrées sur votre appareil. Quitter sans enregistrer ?",
    "DeviceModal_PromptConfirm": "Sortie",
    "DeviceModal_PromptCancel": "Annuler",
    "DeviceModal_Tab_General": "Détails",
    "DeviceModal_Tab_Advanced": "Avancé",
    "DeviceModal_Tab_Monitoring": "Surveillance",
    "DeviceModal_Tab_DeviceMembers": "Membres de l'appareil",
    "DeviceModal_Tab_AgentMembers": "Membres agents",
    "DeviceModal_Tab_DnisMembers": "DNIS",
    "DeviceModal_Tab_LinkedEntities": "Entités liées",
    "DeviceModal_Loading": "Chargement...",
    "DeviceModal_Button_Close": "Fermer",
    "DeviceModal_Button_Cancel": "Annuler",
    "DeviceModal_Button_Save": "Sauvegarder",
    "DeviceModal_RequestFailed": "La requête a échoué",
    "DeviceModal_General_IdentifierGuid": "Identifiant (GUID)",
    "DeviceModal_General_IdentifierPlaceholder": "[Attribution automatique]",
    "DeviceModal_General_GuidPendingHelp": "L'identifiant est attribué après l'enregistrement de l'appareil.",
    "DeviceModal_General_DeviceNumber": "Numéro de l'appareil",
    "DeviceModal_General_DeviceNumberRequired": "Le numéro d'appareil est requis.",
    "DeviceModal_General_Description": "Description",
    "DeviceModal_General_DescriptionRequired": "Une description est requise.",
    "DeviceModal_General_DeviceType": "Type d'appareil",
    "DeviceModal_General_DeviceTypeRequired": "Le type d'appareil est requis.",
    "DeviceModal_General_Partition": "Partition",
    "DeviceModal_General_PartitionRequired": "Une cloison est nécessaire",
    "DeviceModal_General_None": "Aucun",
    "DeviceModal_General_IDOnTelSys": "Identifiant sur le serveur de téléphonie",
    "DeviceModal_General_IDOnTelSys_Broadworks": "Identifiant utilisateur BroadWorks",
    "DeviceModal_General_IDOnTelSys_Webex": "Identifiant utilisateur d'appel Webex",
    "DeviceModal_General_IDOnTelSys_MsTeams": "Identifiant utilisateur MSTeams",
    "DeviceModal_General_IDOnTelSys_Panasonic": "ID sur le serveur de téléphonie",
    "DeviceModal_General_IDOnTelSys_M6": "OID sur serveur téléphonique",
    "DeviceModal_General_IDOnTelSysOwner": "ID du groupe propriétaire",
    "DeviceModal_General_IDOnTelSysDivision": "Département propriétaire (chemin complet)",
    "DeviceModal_General_InternalExtension": "Adresse d'appel interne",
    "DeviceModal_General_TelSysUserID": "Identifiant utilisateur du serveur de téléphonie",
    "DeviceModal_General_TelSysUserID_WebexCiscoCommonIdentity": "Identité commune Cisco",
    "DeviceModal_General_TelSysUserID_MsTeamsUpnUrn": "Nom d'utilisateur principal (URN)",
    "DeviceModal_General_TelSysPassword": "Mot de passe du serveur de téléphonie",
    "DeviceModal_General_TelSysMonitorPassword": "Surveiller le mot de passe",
    "DeviceModal_General_PrimaryEmail": "Adresse e-mail principale",
    "DeviceModal_General_UpdateExistingItems": "Mettez à jour les éléments existants si des doublons sont trouvés.",
    "DeviceModal_Monitoring_OverrideMonitoring": "Surveillance de contournement (non surveillée)",
    "DeviceModal_Monitoring_DisableRTMonitoring": "Désactiver la surveillance en temps réel",
    "DeviceModal_Members_DeviceNumber": "Numéro de l'appareil",
    "DeviceModal_Members_Description": "Description",
    "DeviceModal_Members_AgentNumber": "Numéro d'agent",
    "DeviceModal_Members_Actions": "Actes",
    "DeviceModal_Members_Add": "Ajouter un membre",
    "DeviceModal_Members_AddHotkey": "Ajouter un membre (Ctrl+Entrée)",
    "DeviceModal_Members_Remove": "Supprimer un membre",
    "DeviceModal_Members_Search": "Recherche de membres",
    "DeviceModal_Members_NoDeviceMembers": "Aucun membre de l'appareil",
    "DeviceModal_Members_NoAgentMembers": "Aucun membre agent",
    "DeviceModal_Members_DnisNumber": "Numéro DNIS",
    "DeviceModal_Members_AddDnis": "Ajouter DNIS",
    "DeviceModal_Members_AddDnisHotkey": "Ajouter DNIS (Ctrl+Entrée)",
    "DeviceModal_Members_NoDnisMembers": "Aucune association DNIS",
    "DeviceModal_LinkedEntities_Loading": "Chargement des entités liées…",
    "DeviceModal_LinkedEntities_Empty": "Aucun",
    "DeviceModal_LinkedEntities_Section_Groups": "Adhésions de groupe",
    "DeviceModal_LinkedEntities_Section_Users": "Utilisateurs associés",
    "DeviceModal_LinkedEntities_Column_GroupId": "Groupe",
    "DeviceModal_LinkedEntities_Column_Description": "Description",
    "DeviceModal_LinkedEntities_Column_UserId": "Utilisateur"
}